import React from "react";
import * as Icons from "lucide-react";
import { whySteps } from "../mock";

export default function WhyEasy() {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">We Made Courier Medicines <span className="text-teal-600">EASY</span></h2>
          <p className="mt-3 text-slate-600">Everything handled end-to-end so you never have to worry about a thing.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whySteps.map((s) => {
            const Icon = Icons[s.icon] || Icons.CheckCircle2;
            return (
              <div key={s.no} className="relative bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-teal-200 hover:bg-teal-50/40 transition-colors">
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-blue-600 text-white flex items-center justify-center shrink-0">
                    <Icon className="w-6 h-6" />
                  </div>
                  <span className="text-4xl font-extrabold text-slate-200">{s.no}</span>
                </div>
                <h4 className="font-bold text-slate-900 mb-2 leading-snug">{s.title}</h4>
                <p className="text-sm text-slate-500 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
